import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { TransformationSection } from '../components/sales/TransformationSection';
import { HowItWorksSection } from '../components/sales/HowItWorksSection';
import { SystemSection } from '../components/sales/SystemSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { InsideSection } from '../components/sales/InsideSection';
import { UseCasesSection } from '../components/sales/UseCasesSection';
import { TimeSavingSection } from '../components/sales/TimeSavingSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { LibrarySection } from '../components/sales/LibrarySection';
import { CheckoutSection } from '../components/sales/CheckoutSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalCtaSection } from '../components/sales/FinalCtaSection';
import { SiteFooter } from '../components/sales/SiteFooter';
import { StickyMobileCta } from '../components/StickyMobileCta';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-294" data-mp="30t5d7b0z5cr2">
      <header className="border-b border-brand-charcoal/10 bg-brand-ivory" data-id="element-295" data-mp="2vvlplkidznmg">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-296" data-mp="3tic9e3cyhq95">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-297" data-mp="3ojr9y65j3alr">
            Makeup Instructor <span className="text-brand-gold" data-id="element-298" data-mp="3jjdcfi1jzj1z">Ready</span>
          </p>
        </div>
      </header>

      <main data-id="element-299" data-mp="3fhrrrais20h8">
        <HeroSection data-id="element-300" data-mp="3fi1kh5v7ilqm" />
        <ProblemSection data-id="element-301" data-mp="3fkw3csyknyhx" />
        <TransformationSection data-id="element-302" data-mp="284zqwju9vfp4" />
        <HowItWorksSection data-id="element-303" data-mp="286asqe45qddl" />
        <SystemSection data-id="element-304" data-mp="286knef05d8pm" />
        <VolumesSection data-id="element-305" data-mp="243nxs4c6wcc6" />
        <InsideSection data-id="element-306" data-mp="2434qrio2v8cx" />
        <UseCasesSection data-id="element-307" data-mp="242uzzsv7kx66" />
        <TimeSavingSection data-id="element-308" data-mp="245qybiayxnv5" />
        <BonusesSection data-id="element-309" data-mp="25l32f5t2ue00" />
        <LibrarySection data-id="element-310" data-mp="25kjt2dhhsxxl" />
        <CheckoutSection data-id="element-311" data-mp="25lct6vly4p6r" />
        <AudienceSection data-id="element-312" data-mp="25iz1mwqh5v3y" />
        <FaqSection data-id="element-313" data-mp="2akg0kmpef7hw" />
        <FinalCtaSection data-id="element-314" data-mp="2aiv7l1iqfwm5" />
      </main>

      <SiteFooter data-id="element-315" data-mp="2ahts8kuoonym" />
      <StickyMobileCta data-id="element-316" data-mp="1vmnm7xvl8p5a" />
    </div>;
}